// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { OutcomeFormCategoryInformationFragmentDoc } from '../../__generated-gql-types__/OutcomeForm.generated';
import {
  ReviewFormCoachFragmentDoc,
  ReviewFormReviewFragmentDoc,
} from '../../__generated-gql-types__/ReviewForm.generated';
export type LeaveAReviewModalCoachFragment = {
  __typename?: 'Coach';
  id: string;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    category: {
      __typename?: 'Category';
      id: string;
      goal: Types.GoalName;
      name: string;
      subCategoryTitle?: string | null;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        name: string;
      }> | null;
    };
  }> | null;
};

export type LeaveAReviewModalReviewFragment = {
  __typename?: 'Review';
  id: string;
  rate: number;
  headline?: string | null;
  comment?: string | null;
  anonymous: boolean;
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
  categoryReviews?: Array<{
    __typename?: 'CategoryReview';
    knowledge?: number | null;
    value?: number | null;
    responsiveness?: number | null;
    supportiveness?: number | null;
    category: { __typename?: 'Category'; id: string };
  }> | null;
};

export type LeaveAReviewModalSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  content:
    | {
        __typename?: 'BootcampSession';
        cohort: {
          __typename?: 'BootcampCohort';
          id: string;
          sessions: Array<{ __typename?: 'CoachingSession'; id: string }>;
        };
        bootcamp: {
          __typename?: 'Bootcamp';
          id: string;
          category: { __typename?: 'Category'; id: string };
        };
      }
    | { __typename?: 'Class' }
    | { __typename?: 'OneOnOneSession' };
};

export const LeaveAReviewModalCoachFragmentDoc = gql`
  fragment LeaveAReviewModal_Coach on Coach {
    id
    user {
      id
      firstName
      lastName
      pictureLink
    }
    categoryInformationList(showHidden: false) {
      ...OutcomeForm_CategoryInformation
    }
    ...ReviewForm_Coach
  }
  ${OutcomeFormCategoryInformationFragmentDoc}
  ${ReviewFormCoachFragmentDoc}
`;
export const LeaveAReviewModalReviewFragmentDoc = gql`
  fragment LeaveAReviewModal_Review on Review {
    ...ReviewForm_Review
  }
  ${ReviewFormReviewFragmentDoc}
`;
export const LeaveAReviewModalSessionFragmentDoc = gql`
  fragment LeaveAReviewModal_Session on CoachingSession {
    id
    content {
      ... on BootcampSession {
        cohort {
          id
          sessions(timeFilter: UPCOMING) {
            id
          }
        }
        bootcamp {
          id
          category {
            id
          }
        }
      }
    }
  }
`;
